var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFriendlyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8621 16.0345V24.3104L6.20691 30.5173L11.3793 36.2069L11.8966 43.4483L17.5862 45.5173L24.3104 51.2069L29.4828 49.138L37.7586 52.2414L40.8621 45.5173L48.6207 42.4138C48.4483 40.3449 48.2069 36.1035 48.6207 35.6897C49.0345 35.2759 51.5517 31.0345 52.7586 28.9656L49.6552 24.8276V16.0345L39.8276 12.4138L37.7586 7.24142C34.6552 8.10349 28.3448 9.72418 27.931 9.31039C27.5173 8.8966 23.9655 8.44832 22.2414 8.27591L18.1035 13.9656L10.8621 16.0345Z",
    fill: "#FDE047",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 56.25L16.75 48.25L7.75 46.25L8.625 37L2.5 30L8.625 23L7.75 13.75L16.75 11.75L21.5 3.75L30 7.375L38.5 3.75L43.25 11.75L52.25 13.75L51.375 23L57.5 30L51.375 37L52.25 46.25L43.25 48.25L38.5 56.25L30 52.625L21.5 56.25ZM23.625 49.875L30 47.125L36.5 49.875L40 43.875L46.875 42.25L46.25 35.25L50.875 30L46.25 24.625L46.875 17.625L40 16.125L36.375 10.125L30 12.875L23.5 10.125L20 16.125L13.125 17.625L13.75 24.625L9.125 30L13.75 35.25L13.125 42.375L20 43.875L23.625 49.875ZM27.375 38.875L41.5 24.75L38 21.125L27.375 31.75L22 26.5L18.5 30L27.375 38.875Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendlyHover);
export default __webpack_public_path__ + "static/media/user-friendly-hover.1bff83dae7641d89dcdab8bb5536c8c0.svg";
export { ForwardRef as ReactComponent };